import { IconButton, SideNavItem as SideNavItemComponent, Stack } from '@ui-components/neo.tax';
import { ReactComponent as Check } from '@ui-components/neo.tax/dist/icons/check.svg';
import { useLocation } from 'react-router-dom';

import { NavLinkTo } from '../navigate';
import { IconsContainerStack, StyledSideNavItem } from './side-nav.styled';

export interface SideNavItemProps {
  icon: React.ReactElement;
  id: string;
  title: string;
  to: string;
  isCompleted?: boolean;
  subLinks?: {
    id: string;
    icon: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
    to: string;
  }[];
}

export const SideNavItem = ({
  icon,
  id,
  isCompleted,
  subLinks,
  title,
  to,
}: SideNavItemProps): React.ReactElement | null => {
  const { pathname } = useLocation();
  const isActive = pathname.includes(to);

  const commonProps = {
    active: isActive,
    icon: icon,
    id: id,
    title: title,
    as: 'div' as const,
    badge: isCompleted ? { colorVariant: 'darkGreen' as const, dot: false, children: <Check width={15} /> } : undefined,
  };

  if (!subLinks)
    return (
      <NavLinkTo to={to}>
        <SideNavItemComponent {...commonProps} />
      </NavLinkTo>
    );
  return (
    <Stack direction="column">
      <NavLinkTo to={to}>
        <StyledSideNavItem {...commonProps} />
      </NavLinkTo>
      {subLinks && (
        <IconsContainerStack as="ul" $active={isActive} justifyContent="end" gap="px">
          {subLinks.map(({ icon, id, to }) => (
            <li key={id}>
              <NavLinkTo to={to}>
                {({ isActive }): React.ReactElement => (
                  <IconButton
                    active={isActive}
                    id={id}
                    as="div"
                    tabIndex={-1}
                    variant="gray"
                    icon={{
                      node: icon,
                      isNotificationToggled: false,
                    }}
                    size="lg"
                  />
                )}
              </NavLinkTo>
            </li>
          ))}
        </IconsContainerStack>
      )}
    </Stack>
  );
};
